import { getCachedPopOutTimestamp, getCachedActiveChatTimestamp } from "@nib-group/chatbot-shared/local-storage";
import { CONFIG as LAUNCH_CONFIG } from "@nib-group/chatbot-shared/launch-utils";
/**
 * Helper function to compare a given timestamp to the current time,
 * and return whether the diff falls within the provided threshold.
 */
const getTimestampDiff = (timestamp, threshold) => {
  if (!timestamp) return false;
  const lastActiveTime = new Date(timestamp).getTime();
  const currentTime = Date.now();
  const deltaMs = currentTime - lastActiveTime;
  return deltaMs < threshold;
};
/**
 * Retrieve any cached chat timestamp (inline, pop-out, or other),
 * compare it to the current time, and use that inference to ascertain
 * whether a cached session ID is worth an attempt to resume.
 *
 * i.e. avoid resuming chat sessions older than ...
 */
export const checkActiveChatRecency = () => getTimestampDiff(getCachedActiveChatTimestamp(), LAUNCH_CONFIG.ACTIVE_CHAT_TIMESTAMP_ACCEPTABLE_THRESHOLD);
/**
 * Retrieve any cached chat pop-out timestamp, compare it to the
 * current time, and use that inference to ascertain whether
 * there is an chat pop-out window active somewhere.
 */
export const checkForActivePopOutChat = () => getTimestampDiff(getCachedPopOutTimestamp(), LAUNCH_CONFIG.POP_OUT_ACTIVE_TIMESTAMP_ACCEPTABLE_THRESHOLD);